/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsdoc/require-jsdoc */

export const priorityColors: { [key: string]: string } = {
  high: '#FF5245',
  medium: '#FFAD1A',
  low: '#38DC62'
};

export const dynamicLineColorPlugin = {
  id: 'dynamicLineColorPlugin',
  beforeDatasetDraw(chart: any) {
    const { dynamicLineColorPlugin: plugin } = chart.options.plugins;
    if (!plugin.enabled) {
      return;
    }
    const { ctx } = chart;
    const { datasets } = chart.data;
    const activeIndex = chart.options.plugins.opacityPlugin.activeDatasetIndex;
    datasets.forEach((dataset: any, datasetIndex: any) => {
      if (!chart.isDatasetVisible(datasetIndex)) return;

      const meta = chart.getDatasetMeta(datasetIndex);
      const dataPoints = meta.data;
      const { data } = dataset;

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < dataPoints.length - 1; i++) {
        const currentPoint = dataPoints[i];
        const nextPoint = dataPoints[i + 1];
        const nextPriority = data[i + 1].priority;

        const lineColor = priorityColors[nextPriority] || 'white';
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(currentPoint.x, currentPoint.y);
        ctx.lineTo(nextPoint.x, nextPoint.y);
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = 2;
        if (activeIndex !== null) {
          ctx.globalAlpha = datasetIndex === activeIndex ? 1 : 0.1;
        }
        ctx.stroke();
        ctx.restore();
      }
    });
  }
};

export const textPointPlugin = {
  id: 'textPointPlugin',
  afterDatasetsDraw(chart: any) {
    const { textPointPlugin: plugin } = chart.options.plugins;
    if (!plugin.enabled) {
      return;
    }
    const { ctx, data } = chart;
    const { datasets } = data;

    const defaultFontSize = 6;
    const padding = 2;
    const activeIndex = chart.options.plugins.opacityPlugin.activeDatasetIndex;
    datasets.forEach((dataset: any, datasetIndex: any) => {
      if (chart.isDatasetVisible(datasetIndex)) {
        const meta = chart.getDatasetMeta(datasetIndex);
        // const text = dataset.pointStyleText;

        ctx.font = `normal ${defaultFontSize}px Inter`;

        meta.data.forEach((dataPoint: any, index: number) => {
          if (dataPoint) {
            // const prevDataPoint = meta.data[index - 1];
            // const nextDataPoint = meta.data[index + 1];
            const showPoint =
              index === 0 ||
              index === Math.round(meta.data.length * 0.3) ||
              index === Math.round(meta.data.length * 0.6) ||
              // index === Math.round(meta.data.length * 0.25) ||
              // index === Math.round(meta.data.length * 0.75) ||
              index === (meta.data.length >= 3 ? meta.data.length - 2 : meta.data.length - 1);
            // prevDataPoint && nextDataPoint
            //   ? prevDataPoint.y !== dataPoint.y || nextDataPoint.y !== dataPoint.y
            //   : true;

            if (showPoint) {
              ctx.save();
              if (activeIndex !== null) {
                ctx.globalAlpha = datasetIndex === activeIndex ? 1 : 0.1;
              }
              // const textWidth = ctx.measureText(text).width;
              // const textHeight = defaultFontSize;

              const radius = Math.max(5, 5) / 2 + padding;

              ctx.fillStyle = dataset.labelColor;
              ctx.beginPath();
              ctx.arc(dataPoint.x, dataPoint.y, radius, 0, Math.PI * 2);
              ctx.closePath();
              ctx.fill();

              // ctx.fillStyle = dataset.labelColor;
              // ctx.textAlign = 'center';
              // ctx.textBaseline = 'middle';
              // ctx.fillText(text, dataPoint.x, dataPoint.y);

              ctx.restore();
            }
          }
        });
      }
    });
  },

  beforeDatasetDraw(chart: any) {
    const { textPointPlugin: plugin } = chart.options.plugins;
    if (!plugin.enabled) {
      return;
    }
    const { datasets } = chart.data;
    datasets.forEach((dataset: any, datasetIndex: any) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((dataPoint: any, index: number) => {
        // const prevDataPoint = meta.data[index - 1];
        // const nextDataPoint = meta.data[index + 1];
        const showPoint =
          index === 0 ||
          index === Math.round(meta.data.length * 0.3) ||
          index === Math.round(meta.data.length * 0.6) ||
          // index === Math.round(meta.data.length * 0.25) ||
          // index === Math.round(meta.data.length * 0.75) ||
          index === (meta.data.length >= 3 ? meta.data.length - 2 : meta.data.length - 1);
        // const showPoint =
        //   prevDataPoint && nextDataPoint
        //     ? prevDataPoint.y !== dataPoint.y || nextDataPoint.y !== dataPoint.y
        //     : true;
        if (!showPoint) {
          // eslint-disable-next-line no-param-reassign
          dataPoint.hidden = true;
        }
      });
    });
  }
};

const hexToRgba = (hex: string, alpha: number): string => {
  if (!/^#[0-9A-F]{6}$/i.test(hex)) {
    return 'rgba(0, 0, 0, 1)';
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const createOpacityPlugin = (): any => {
  let lastDatasetIndex: number | null = null;
  let updateTimeout: number | null = null;

  return {
    id: 'opacityPlugin',
    beforeEvent(chart: any, args: any) {
      const { event } = args;
      const { datasets } = chart.data;

      if (updateTimeout) {
        clearTimeout(updateTimeout);
      }

      updateTimeout = window.setTimeout(() => {
        if (event.type === 'click') {
          const elements = chart.getElementsAtEventForMode(
            event,
            'nearest',
            { intersect: true },
            false
          );

          if (elements.length) {
            const { datasetIndex } = elements[0];
            if (datasetIndex !== lastDatasetIndex) {
              lastDatasetIndex = datasetIndex;
              let updateRequired = false;

              datasets.forEach((dataset: any, index: number) => {
                if (!dataset._originalBorderColor) {
                  dataset._originalBorderColor = dataset.borderColor;
                  dataset._originalBackgroundColor = dataset.backgroundColor;
                }

                if (index === datasetIndex) {
                  if (dataset.borderColor !== hexToRgba(dataset._originalBorderColor, 1)) {
                    dataset.borderColor = hexToRgba(dataset._originalBorderColor, 1);
                    dataset.backgroundColor = hexToRgba(dataset._originalBackgroundColor, 0.4);
                    updateRequired = true;
                  }
                } else if (dataset.borderColor !== hexToRgba(dataset._originalBorderColor, 0.1)) {
                  dataset.borderColor = hexToRgba(dataset._originalBorderColor, 0.1);
                  dataset.backgroundColor = hexToRgba(dataset._originalBackgroundColor, 0.1);
                  updateRequired = true;
                }
              });

              if (updateRequired) {
                chart.update('none');
              }
            }
          }
        } else if (event.type === 'mouseout') {
          lastDatasetIndex = null;
          let updateRequired = false;

          datasets.forEach((dataset: any) => {
            if (dataset._originalBorderColor) {
              if (dataset.borderColor !== hexToRgba(dataset._originalBorderColor, 1)) {
                dataset.borderColor = hexToRgba(dataset._originalBorderColor, 1);
                dataset.backgroundColor = hexToRgba(dataset._originalBackgroundColor, 0.4);
                updateRequired = true;
              }
            }
          });

          if (updateRequired) {
            chart.update('none');
          }
        }
      }, 50);
    }
  };
};

export const customAxisTitlePlugin = {
  id: 'customAxisTitlePlugin',
  afterDraw: (chart: any) => {
    const { ctx, options, scales } = chart;
    Object.keys(scales).forEach((axisId) => {
      const axis = scales[axisId];
      const axisOptions = options.scales[axisId];
      if (axis && axisOptions?.title?.display) {
        const title = axisOptions.title.text;
        const x = axis.left + axis.width / 2;
        const y = axis.top - 10;

        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        ctx.fillStyle = axisOptions.title.color || '#000';
        ctx.font = `bold ${axisOptions.title.font?.size || 15}px Arial`;
        ctx.fillText(title, x, y);
        ctx.restore();
      }
    });
  }
};

/** One point captured inside a pinned tooltip (one series at one index). */
export interface PinnedTooltipPoint {
  datasetIndex: number;
  index: number;
  color: string;
  /**
   * The point's x value at the moment it was pinned, when the series carries
   * one.
   *
   * WHY: `index` is a position in the dataset array, and on a live chart that
   * array both grows at the end and is trimmed at the front, so the same index
   * means a different sample a second later. Charts whose data never shifts
   * underneath them are unaffected — they simply resolve by `index` as before.
   */
  anchorX?: number;
}

/**
 * A datum's x as a number, or null when it has none to anchor to.
 * @param datum - One entry from a dataset's `data` array.
 * @returns The x value in milliseconds, or null.
 */
function anchorValue(datum: any): number | null {
  const x = datum && typeof datum === 'object' ? datum.x : undefined;
  if (x instanceof Date) return x.getTime();
  return typeof x === 'number' && Number.isFinite(x) ? x : null;
}

/**
 * Where a pinned point sits in the dataset NOW.
 *
 * Returns the stored index for series that carry no x value to anchor to, so
 * nothing changes for them. For anchored points it finds the sample with that
 * exact x — data is in time order, so this is a binary search — and returns
 * null when it has gone, which drops the pin instead of silently re-pointing
 * it at whichever sample inherited the index.
 * @param chart - The Chart.js instance.
 * @param point - The pinned point to locate.
 * @returns The current index, or null when the sample is no longer present.
 */
export function resolvePinIndex(chart: any, point: PinnedTooltipPoint): number | null {
  if (point.anchorX === undefined) return point.index;
  const data = chart?.data?.datasets?.[point.datasetIndex]?.data;
  if (!Array.isArray(data) || data.length === 0) return null;
  if (anchorValue(data[0]) === null) return point.index;
  let lo = 0;
  let hi = data.length - 1;
  while (lo <= hi) {
    // eslint-disable-next-line no-bitwise
    const mid = (lo + hi) >> 1;
    const x = anchorValue(data[mid]);
    if (x === null) return point.index;
    if (x === point.anchorX) return mid;
    if (x < point.anchorX) lo = mid + 1;
    else hi = mid - 1;
  }
  return null;
}

/**
 * A tooltip the user froze onto the chart by clicking a point. Content is
 * captured from Chart.js' own tooltip model at click time so a pinned box
 * reads exactly like the hover tooltip it was made from.
 */
export interface PinnedTooltip {
  /** Stable key of the pinned points, used to toggle the pin off. */
  id: string;
  /** Every series/point the tooltip covered (index mode pins a whole column). */
  points: PinnedTooltipPoint[];
  /** Tooltip title lines (usually the formatted timestamp). */
  title: string[];
  /** One body line per series, with that series' colour. */
  lines: { text: string; color: string }[];
}

/**
 * Draws tooltips the user pinned by clicking a data point, so several points
 * can stay on screen at once. Pins are supplied via
 * `chart.options.plugins.pinnedTooltipsPlugin.pins` as {@link PinnedTooltip}s.
 * The pin under the cursor is skipped while the live hover tooltip is up, so
 * the two never draw on top of each other.
 */
export const pinnedTooltipsPlugin = {
  id: 'pinnedTooltipsPlugin',
  afterDatasetsDraw(chart: any) {
    const plugin = chart.options?.plugins?.pinnedTooltipsPlugin;
    if (!plugin?.enabled || !Array.isArray(plugin.pins) || plugin.pins.length === 0) return;
    const { ctx, chartArea } = chart;
    if (!chartArea) return;

    // The column the live tooltip is currently drawing; its pin is skipped.
    // Compared on the indices the pin resolves to RIGHT NOW rather than on the
    // id it was created with, because an anchored pin's index moves as the
    // data scrolls while its id does not.
    const { tooltip } = chart;
    const hovered: Set<string> | null =
      tooltip && tooltip.opacity > 0 && tooltip.dataPoints?.length
        ? new Set<string>(
            tooltip.dataPoints.map((p: any) => `${p.datasetIndex}:${p.dataIndex}`)
          )
        : null;

    const fontSize = plugin.fontSize || 12;
    const family = 'Inter, Arial, sans-serif';
    const padding = 8;
    const gap = 4;
    const swatch = 8;
    const lineHeight = fontSize + gap;
    const borderColor = plugin.borderColor || 'rgba(99,102,241,0.55)';
    const textColor = plugin.textColor || '#E5E7EB';
    const drawn: { left: number; top: number; right: number; bottom: number }[] = [];

    plugin.pins.forEach((pin: PinnedTooltip) => {
      // Resolve the pinned points that are still on screen (a legend toggle, a
      // data refresh, or the sample scrolling out of a live window can take
      // some of them away).
      const resolved = pin.points
        .map((p) => {
          const meta = chart.getDatasetMeta(p.datasetIndex);
          if (!meta || meta.hidden) return null;
          const index = resolvePinIndex(chart, p);
          if (index === null) return null;
          const element = meta.data?.[index];
          return element ? { element, color: p.color, key: `${p.datasetIndex}:${index}` } : null;
        })
        .filter(Boolean) as { element: any; color: string; key: string }[];
      if (resolved.length === 0) return;
      // Skip the pin the live tooltip is already drawing over.
      if (hovered && resolved.every((a) => hovered.has(a.key))) return;
      const anchors = resolved;

      const px = anchors[0].element.x;
      const py = Math.min(...anchors.map((a) => a.element.y));

      ctx.save();

      // Pinned column marker.
      ctx.beginPath();
      ctx.setLineDash([4, 4]);
      ctx.moveTo(px, chartArea.top);
      ctx.lineTo(px, chartArea.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = borderColor;
      ctx.stroke();
      ctx.setLineDash([]);

      // Point markers, one per pinned series.
      anchors.forEach(({ element, color }) => {
        ctx.beginPath();
        ctx.arc(element.x, element.y, 4, 0, Math.PI * 2);
        ctx.fillStyle = color || '#6366F1';
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 2;
        ctx.fill();
        ctx.stroke();
      });

      // Box geometry from the widest line.
      ctx.font = `600 ${fontSize}px ${family}`;
      let textWidth = pin.title.reduce((w, t) => Math.max(w, ctx.measureText(t).width), 0);
      ctx.font = `${fontSize}px ${family}`;
      pin.lines.forEach((l) => {
        textWidth = Math.max(textWidth, swatch + 6 + ctx.measureText(l.text).width);
      });
      const rows = pin.title.length + pin.lines.length;
      const boxWidth = textWidth + padding * 2;
      const boxHeight = rows * lineHeight - gap + padding * 2;

      // Prefer the right of the point, flip left when it would overflow, then
      // nudge down (or up) until the box clears the ones already drawn.
      let boxX = px + 14;
      if (boxX + boxWidth > chartArea.right) boxX = px - 14 - boxWidth;
      if (boxX < chartArea.left) boxX = chartArea.left;
      let boxY = py - boxHeight - 12;
      if (boxY < chartArea.top) boxY = py + 12;
      const overlaps = (top: number): boolean =>
        drawn.some(
          (r) =>
            boxX < r.right && boxX + boxWidth > r.left && top < r.bottom && top + boxHeight > r.top
        );
      let guard = 0;
      // eslint-disable-next-line no-plusplus
      while (overlaps(boxY) && guard++ < 12) {
        boxY += boxHeight + 6;
        if (boxY + boxHeight > chartArea.bottom) {
          boxY = Math.max(chartArea.top, py - boxHeight - 12 - (boxHeight + 6) * guard);
          break;
        }
      }
      boxY = Math.min(Math.max(boxY, chartArea.top), chartArea.bottom - boxHeight);
      drawn.push({ left: boxX, top: boxY, right: boxX + boxWidth, bottom: boxY + boxHeight });

      // Connector from the pinned point to the box.
      ctx.beginPath();
      ctx.moveTo(px, py);
      ctx.lineTo(boxX > px ? boxX : boxX + boxWidth, boxY + boxHeight / 2);
      ctx.lineWidth = 1;
      ctx.strokeStyle = borderColor;
      ctx.stroke();

      // Box.
      const radius = 6;
      ctx.beginPath();
      ctx.moveTo(boxX + radius, boxY);
      ctx.arcTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + boxHeight, radius);
      ctx.arcTo(boxX + boxWidth, boxY + boxHeight, boxX, boxY + boxHeight, radius);
      ctx.arcTo(boxX, boxY + boxHeight, boxX, boxY, radius);
      ctx.arcTo(boxX, boxY, boxX + boxWidth, boxY, radius);
      ctx.closePath();
      ctx.fillStyle = plugin.backgroundColor || 'rgba(17, 24, 39, 0.96)';
      ctx.fill();
      ctx.strokeStyle = borderColor;
      ctx.lineWidth = 1;
      ctx.stroke();

      // Title, then one body line per series.
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      let rowY = boxY + padding + fontSize / 2;
      ctx.font = `600 ${fontSize}px ${family}`;
      ctx.fillStyle = textColor;
      pin.title.forEach((t) => {
        ctx.fillText(t, boxX + padding, rowY);
        rowY += lineHeight;
      });
      ctx.font = `${fontSize}px ${family}`;
      pin.lines.forEach((l) => {
        ctx.fillStyle = l.color || '#6366F1';
        ctx.fillRect(boxX + padding, rowY - swatch / 2, swatch, swatch);
        ctx.fillStyle = textColor;
        ctx.fillText(l.text, boxX + padding + swatch + 6, rowY);
        rowY += lineHeight;
      });

      ctx.restore();
    });
  }
};
